import { render, staticRenderFns } from "./SelectedRider.vue?vue&type=template&id=3bfd26de&scoped=true&"
import script from "./SelectedRider.vue?vue&type=script&lang=js&"
export * from "./SelectedRider.vue?vue&type=script&lang=js&"
import style0 from "./SelectedRider.vue?vue&type=style&index=0&id=3bfd26de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd26de",
  null
  
)

export default component.exports